<template>
	<div>
		<!-- Breadcrumb -->
		<Breadcrumb :bread="bread"/>
		<v-container>
			<v-row justify="center">
				<v-data-table
					:headers="headers"
					:items="items"
					:items-per-page=15
					item.key='items.id'
					no-data-text="Cargando Items ..."
					 v-if='loaded'
				>

					<!-- slot Top table -->
					<template v-slot:top>
						<v-toolbar flat color="white">
							<v-toolbar-title>Gestión de Items</v-toolbar-title>
							<v-divider class="mx-4" inset vertical></v-divider>
							<v-spacer />
							<item-dialog />
						</v-toolbar>
					</template>
					<!-- Order -->
					<template v-slot:item.order="{ item }">
							<v-layout justify-center align-center>
								<v-icon @click="toggleOrder(item,'up')" size="32" color="grey darken-1">mdi-menu-up</v-icon>
								{{item.order}}
								<v-icon @click="toggleOrder(item,'down')" size="32" color="grey darken-1">mdi-menu-down</v-icon>
							</v-layout>
					</template>
					<!-- Destacado -->
					<template v-slot:item.featured="{ item }">
						<v-layout justify-center>
							<v-switch
								color="success"
								v-model="item.featured"
								@change="toogleFeatured(item)"
							></v-switch>
						</v-layout>
					</template>
					<!-- Visible -->
					<template v-slot:item.visible="{ item }">
						<v-layout justify-center>
							<v-switch
								color="success"
								v-model="item.visible"
								@change="toogleVisible(item)"
							></v-switch>
						</v-layout>
					</template>
					<template v-slot:item.action="{ item }">
						<v-icon color="admin_secondary"  @click="edit(item)">
							mdi-file-edit
						</v-icon>
						<v-icon
							@click="remove(item, items.map(function(x) {return x.id; }).indexOf(item.id))"
							color="red"
						>
							mdi-delete
						</v-icon>
					</template>

				</v-data-table>			
			</v-row>
		</v-container>
		<v-container v-if='!loaded' fill-height>
			<v-layout flex align-center justify-center>
				<v-progress-circular indeterminate :size="100" :widht="45" color="secondary" />
			</v-layout>
		</v-container>


	</div>
</template>

<script>
	import { mapState, mapActions, mapGetters} from 'vuex';
	import { db } from '@/main';
	export default {
		components: {
			ItemDialog: () => import('@/components/admin/ItemDialog'),
			Breadcrumb: () => import('@/components/admin/Breadcrumb.vue'),
		},
		created(){
			// this.business_id =this.$route.params.business_id
			// this.business_name = this.$route.params.business_name
			// this.category_id =this.$route.params.category_id
			// this.category_name = this.$route.params.category_name
			// this.category_subtitle = this.$route.params.category_subtitle
			// console.log(this.business_id)
			// console.log(this.business_name)
			// console.log(this.category_id)
			// console.log(this.category_name)
			// console.log(this.category_subtitle)
			this.getItems( this.$route.params.business_id, this.$route.params.category_id )
		},
		data() {
			const subtitle = (this.$route.params.category_subtitle != null ) ? this.$route.params.category_subtitle : ''
			const negocioActual = this.$route.params.business_name
			const actual = `${this.$route.params.category_name} ${subtitle}`
			const categoriesPrev = `/admin/${this.$route.params.business_id}/${this.$route.params.business_name}/categories`
			return {
				items: [],
				loaded: false,
				business_id: '',
				business_name: '',
				category_id: '',
				category_name: '',
				category_subtitle: '',
				headers: [
					{text: 'Nombre', value: 'name', align: 'left'},
					{text: 'Description', value: 'description', align: 'left'},
					{text: 'Orden', value: 'order', align: 'center'},
					{text: 'Destacado', value: 'featured', align: 'center'},
					{text: 'Visible', value: 'visible', align: 'center'},
					{text: '', value: 'action', sortable: false,align: 'end', },
				],
				bread: [
					{
						text: 'Inicio',
						disabled: false,
						href: '/admin',
					},
					{
						text: 'Negocios',
						disabled: false,
						href: '/admin/negocios',
					},
					{
						text: negocioActual,
						disabled: false,
						href: `/admin/${this.$route.params.business_id}/${this.$route.params.business_name}/categories`,
					},
					{
						text: 'Categorias',
						disabled: false,
						href: categoriesPrev,
					},
					{
						text: actual,
						disabled: true,
						href: '#',
					},
				],
			}
		}, //.v-data
		methods: {
			...mapActions('itemModule', ['toggleItemDialog']),
			getItems(business_id,category_id){
				let regs = []
				try {
					this.loaded = false
					db.collection('bussiness').doc(this.$route.params.business_id)
						.collection('items').where('category_id','==',this.$route.params.category_id)
						.orderBy('order')
						.onSnapshot(snap => {
							regs = []
							snap.forEach(doc => {
								regs.push({ id: doc.id, ...doc.data() })
							})
							this.items = regs;					
							this.loaded = true;
					});						
				} catch (error) { 
					console.log(error) 
					} finally {
						this.loaded = true;
					} 
			}, // .getItems
			toogleFeatured(item){
				db.collection('bussiness').doc(this.$route.params.business_id)
					.collection('items').doc(item.id)
					.update({ featured: item.featured });
			},
			toogleVisible(item){
				db.collection('bussiness').doc(this.$route.params.business_id)
					.collection('items').doc(item.id)
					.update({ visible: item.visible });
			},
			toggleOrder(item,to){
				if ( to == 'down' && item.order < this.items.length){
					const nextItem = this.items.find(e => e.order === item.order+1 )
					db.collection('bussiness').doc(this.$route.params.business_id)
						.collection('items').doc(item.id).update({ order: item.order+1 });
					db.collection('bussiness').doc(this.$route.params.business_id)
						.collection('items').doc(nextItem.id).update({ order: item.order });
				} else if (to == 'up' && item.order > 1) {
					const nextItem = this.items.find(e => e.order === item.order-1 )
					db.collection('bussiness').doc(this.$route.params.business_id)
						.collection('items').doc(item.id).update({ order: item.order-1 });
					db.collection('bussiness').doc(this.$route.params.business_id)
						.collection('items').doc(nextItem.id).update({ order: item.order });
				}
			},
			edit(item){
				this.toggleItemDialog({editMode: true, item})
			},
			async remove(item, index){

				let res = await this.$confirm('Borrará un ITEM. Operación no tiene reverso',
						{
							title: "CUIDADO",
							buttonTrueText: "Aceptar",
							buttonFalseText: "Cancelar",
							color: "red",
							icon: "mdi-hand-right",
							width: 350,
							property: "$confirm",
						})
				if (res) {
					this.items.splice(index,1)
					db.collection('bussiness').doc(this.$route.params.business_id)
					.collection('items').doc(item.id).delete();
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true,
							color: 'error',
							message: 'Item eliminado satisfactoriamente',
							timeout: 1000
						});	
				}


			}			

		}, // .methods
		Computed: {
			...mapState(['alert']),
			...mapGetters('itemModule',['itemForEdit', 'itemDialogEditMode','itemsDialog']),
			itemDialog: {
				get(){
					return this.itemsDialog;
				},
				set(){
					this.close()
				}
			},
			loaded(){
				return this.$store.state.loaded
			},
		}
		
	}
</script>
<style>

	button.v-btn.v-btn--flat.v-btn--text.theme--light.v-size--default.primary--text{
		color:red !important;
	}

</style>

